<div class="tw:w-full tw:p-0 tw:m-0">
  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">

    <div class="tw:w-full tw:p-0 tw:m-0">

      <ng-template #utilityBarForm>
        <!-- display:contents keeps the switch-off layout exactly as it was; .filter-bar turns it into the grid. -->
        <div style="display: contents;" [class.filter-bar]="filtersEnabled">

          @if (filtersEnabled) {
            <div class="filter-bar__field">
              <label class="field__label">Search</label>
              <input class="form-control" [placeholder]="searchPlaceholder" type="text"
                (keydown.enter)="search()" [(ngModel)]="searchText"
                data-toggle="tooltip" data-placement="top" [title]="studentTooltip">
            </div>
          }

          @if (hasStudentSearchClientFilterPermission && showClientFilter) {
            <div class="flex-row filter-bar__group">
              <div class="flex-column filter-bar__field">
                @if (filtersEnabled) {
                  <label class="field__label">Client</label>
                }
                <app-typeahead inputClass="form-control" placeholder="Filter on client name or Id"
                  (keydown.enter)="search()" [(ngModel)]="clientFilter"
                  data-toggle="tooltip" data-placement="top" title="Please enter a client name or Id"
                  [enabled]="autocompleteEnabled" [source]="clientSuggestions.search" [prefetch]="clientSuggestions.prefetch"
                  [displayWith]="clientSuggestions.display" [valueWith]="clientSuggestions.value"></app-typeahead>
                </div>
              </div>
            }

            <ng-container *appFeatureSwitch="featureKeys.filtersLearnerSearch">
              <div class="flex-row filter-bar__group">
                <div class="flex-column filter-bar__group">
                  <app-brand-filter class="filter-bar__field" [(companyIds)]="companyIds"></app-brand-filter>
                </div>
                <div class="flex-column filter-bar__field">
                  <label class="field__label" for="activeBookingFilter">Active booking</label>
                  <select id="activeBookingFilter" class="field__control" [(ngModel)]="hasActiveBooking">
                    <option [ngValue]="null">Any</option>
                    <option [ngValue]="true">Has an active booking</option>
                    <option [ngValue]="false">No active booking</option>
                  </select>
                </div>
                <div class="flex-column filter-bar__field" data-filter="keyStages">
                  <label class="field__label">Key stage</label>
                  <app-searchable-select [(ngModel)]="keyStages" [items]="keyStageOptions"
                    displayField="keyStage" valueField="keyStage" multiple
                    placeholder="Any key stage" searchPlaceholder="Search key stages…"></app-searchable-select>
                </div>
              </div>
            </ng-container>

            @if (!filtersEnabled) {
              <div class="flex-row">
                <div class="flex-column">
                  <div class="input-group tw:mb-4">
                    <input class="form-control" [placeholder]="searchPlaceholder" type="text"
                      (keydown.enter)="search()" [(ngModel)]="searchText"
                      data-toggle="tooltip" data-placement="top" [title]="studentTooltip">
                      <div class="input-group-btn">
                        <button class="btn btn-primary" type="button" (click)="search()">Search</button>
                      </div>
                    </div>
                  </div>
                </div>
              }


              <div class="flex-row filter-bar__field filter-bar__field--check" [hidden]="!showFilters">
                <div class="tw:flex-1 tw:p-0 tw:m-0 tw:justify-start">

                  <div class="tw:inline-flex w-210-px">
                    <label class="field__toggle"><input type="checkbox" [(ngModel)]="unallocatedOnlyFilter" /><span class="field__toggle-track"></span> Only Unallocated</label>
                  </div>

                </div>
              </div>

              @if (filtersEnabled) {
                <div class="filter-bar__actions">
                  <div class="filter-bar__buttons">
                    @if (filterUx) {
                      <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                    }
                    <button class="btn btn-primary" type="button" (click)="search()">Search</button>
                  </div>
                </div>
              }
            </div>
          </ng-template>
          @if (injectedShowSearch) {
            <div [class.filter-bar]="filtersEnabled">
              @if (filtersEnabled) {
                <div class="filter-bar__field">
                  <label class="field__label">Search</label>
                  <input class="form-control" [placeholder]="searchPlaceholder" type="text"
                    (keydown.enter)="search()" [(ngModel)]="searchText"
                    data-toggle="tooltip" data-placement="top" [title]="studentTooltip">
                </div>
              }
              @if (hasStudentSearchClientFilterPermission && showClientFilter) {
                <div class="flex-row filter-bar__group">
                  <div class="flex-column filter-bar__field">
                    @if (filtersEnabled) {
                      <label class="field__label">Client</label>
                    }
                    <app-typeahead inputClass="form-control" placeholder="Filter on client name or Id"
                      (keydown.enter)="search()" [(ngModel)]="clientFilter"
                      data-toggle="tooltip" data-placement="top" title="Please enter a client name or Id"
                      [enabled]="autocompleteEnabled" [source]="clientSuggestions.search" [prefetch]="clientSuggestions.prefetch"
                      [displayWith]="clientSuggestions.display" [valueWith]="clientSuggestions.value"></app-typeahead>
                    </div>
                  </div>
                }
                <ng-container *appFeatureSwitch="featureKeys.filtersLearnerSearch">
                  <div class="flex-row filter-bar__group">
                    <div class="flex-column tw:mx-1 tw:px-0 filter-bar__group">
                      <app-brand-filter class="filter-bar__field" [(companyIds)]="companyIds"></app-brand-filter>
                    </div>
                    <div class="flex-column tw:mx-1 tw:px-0 filter-bar__field">
                      <label class="field__label" for="activeBookingFilterInjected">Active booking</label>
                      <select id="activeBookingFilterInjected" class="field__control" [(ngModel)]="hasActiveBooking">
                        <option [ngValue]="null">Any</option>
                        <option [ngValue]="true">Has an active booking</option>
                        <option [ngValue]="false">No active booking</option>
                      </select>
                    </div>
                    <div class="flex-column tw:mx-1 tw:px-0 filter-bar__field" data-filter="keyStages">
                      <label class="field__label">Key stage</label>
                      <app-searchable-select [(ngModel)]="keyStages" [items]="keyStageOptions"
                        displayField="keyStage" valueField="keyStage" multiple
                        placeholder="Any key stage" searchPlaceholder="Search key stages…"></app-searchable-select>
                    </div>
                  </div>
                </ng-container>
                @if (!filtersEnabled) {
                  <div class="flex-row">
                    <div class="flex-column tw:mx-1 tw:px-0">
                      <div class="input-group tw:mb-4">
                        <input class="form-control" [placeholder]="searchPlaceholder" type="text"
                          (keydown.enter)="search()" [(ngModel)]="searchText"
                          data-toggle="tooltip" data-placement="top" [title]="studentTooltip">
                          <div class="input-group-btn">
                            <button class="btn btn-primary" type="button" (click)="search()">Search</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="flex-row filter-bar__field filter-bar__field--check" [hidden]="!showFilters">
                    <div class="tw:flex-1 tw:p-0 tw:m-0 tw:justify-start">
                      <div class="tw:inline-flex w-210-px">
                        <label class="field__toggle"><input type="checkbox" [(ngModel)]="unallocatedOnlyFilter" /><span class="field__toggle-track"></span> Only Unallocated</label>
                      </div>
                    </div>
                  </div>
                  @if (filtersEnabled) {
                    <div class="filter-bar__actions">
                      <div class="filter-bar__buttons">
                        <button class="btn btn-primary" type="button" (click)="search()">Search</button>
                      </div>
                    </div>
                  }
                </div>
              }

              @if (searchClicked) {
                <div class="flex-row">
                  <div class="flex-column">
                    <app-data-table
                      [columns]="columns"
                      [data]="filteredStudents"
                      [pageSize]="showPaginator ? 10 : 5"
                      emptyMessage="No Learner(s) Found">
                      <ng-template appColumnCell="studentName" let-row>
                        {{row.studentDetailItem.firstName}} {{row.studentDetailItem.surname}}
                      </ng-template>
                      <ng-template appColumnCell="companyId" let-row>
                        {{(row.companyId ?? row.studentDetailItem?.companyId) | brandShortCode: brands}}
                      </ng-template>
                      <ng-template appColumnCell="clientName" let-row>
                        @if (row.studentPupilDetailsItem?.clientName) {
                          <span>{{row.studentPupilDetailsItem?.clientName.trim()}} ({{row.studentPupilDetailsItem?.clientId}})</span>
                        }
                      </ng-template>
                      <ng-template appColumnCell="upn" let-row>
                        {{row.studentPupilDetailsItem?.upn}}
                      </ng-template>
                      <ng-template appColumnCell="mainSubject" let-row>
                        {{row.studentPupilDetailsItem?.mainSubject}}
                      </ng-template>
                      <ng-template appColumnCell="yearGroup" let-row>
                        {{row.studentPupilDetailsItem?.yearGroup}}
                      </ng-template>
                      <ng-template appColumnCell="keyStages" let-row>
                        {{row.keyStages?.length ? row.keyStages.join(', ') : '—'}}
                      </ng-template>
                      <ng-template appColumnCell="actions" let-row>
                        <div class="flex-row">
                          @if (showAddButton) {
                            <div class="flex-column">
                              <button type="button" class="btn btn-primary btn-sm tw:my-0"
                              (click)="emitAddStudentEvent(row)">Add</button>
                            </div>
                          }
                          @if (hasStudentViewPermission) {
                            <div class="flex-column">
                              <button type="button" class="btn btn-primary btn-sm tw:my-0"
                              (click)="viewStudent(row)">View</button>
                            </div>
                          }
                          @if (hasGenerateStudentAccessPermission) {
                            <div class="flex-column">
                              <button type="button" class="btn btn-primary btn-sm tw:my-0"
                              (click)="generateAccess(row)">Generate Access</button>
                            </div>
                          }
                        </div>
                      </ng-template>
                    </app-data-table>
                  </div>
                </div>
              }

            </div>

          </div>
        </div>
